export const config = {
  isOnPremise: import.meta.env.VITE_IS_ON_PREMISE === 'true'
} as const;
